module.exports = __webpack_public_path__ + "img/Delaware outline.51492902.png";